import React from "react";
import { FunnelChart, Funnel, LabelList, Tooltip, ResponsiveContainer, Cell } from "recharts";
import Skeleton from "components/ui/Skeleton";
import { fmtCompact } from "../utils";

const COLORS = ["var(--color-primary)", "var(--color-secondary)", "var(--color-success)", "var(--color-info)"];

const DeliveryFunnel = ({ funnel, loading }) => {
  const rows = funnel || [];
  const total = rows[0]?.value || 0;

  return (
    <div className="rounded-2xl border border-border bg-surface p-5">
      <h2 className="font-semibold text-text_primary mb-1">Delivery Funnel</h2>
      <p className="text-xs text-text_muted mb-2">Aggregate across the selected period</p>

      {loading ? (
        <Skeleton className="h-60 w-full" rounded="rounded-xl" />
      ) : (
        <ResponsiveContainer width="100%" height={220}>
          <FunnelChart>
            <Tooltip formatter={(value) => fmtCompact(value)} />
            <Funnel dataKey="value" data={rows}>
              <LabelList position="right" dataKey="stage" fill="var(--color-text-secondary)" stroke="none" fontSize={12} />
              <LabelList position="left" dataKey="value" formatter={fmtCompact} fill="var(--color-text-primary)" stroke="none" fontSize={12} fontWeight={600} />
              {rows.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
            </Funnel>
          </FunnelChart>
        </ResponsiveContainer>
      )}

      <div className="mt-3 grid grid-cols-2 gap-2">
        {rows.map((f, i) => (
          <div key={f.stage} className="flex items-center justify-between text-xs">
            <span className="flex items-center gap-1.5 text-text_secondary">
              <span className="w-2 h-2 rounded-full inline-block" style={{ backgroundColor: COLORS[i % COLORS.length] }} />
              {f.stage}
            </span>
            <span className="font-semibold text-text_primary tabular-nums">
              {total > 0 ? `${Math.round((f.value / total) * 1000) / 10}%` : "0%"}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DeliveryFunnel;
